import { AvailableModules } from 'generated/featureDefinitions'
import { CheckModuleAvailabilityForShiftsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface UseShiftManagementModuleAvailabilityResult {
  isModuleAvailable: boolean
  isModuleLoading: boolean
  isNotFound: boolean
}

/**
 * Hook to check if shift management module is available for the current company
 * @returns Object containing module availability status and loading state
 */
export const useShiftManagementModuleAvailability =
  (): UseShiftManagementModuleAvailabilityResult => {
    const { data: moduleAvailabilityData, loading } = useQuery(
      CheckModuleAvailabilityForShiftsDocument,
      {
        variables: {
          moduleId: AvailableModules.shift_management,
        },
      }
    )

    const isModuleAvailable =
      moduleAvailabilityData?.companies.moduleAvailability?.available ?? false
    const isNotFound = !isModuleAvailable

    return {
      isModuleAvailable,
      isModuleLoading: loading,
      isNotFound,
    }
  }
